import { format, isValid } from 'date-fns';

export const DATE_NEEDED_BY_MAX_DAYS = 60;

export type DateNeededByValidationError =
  | 'not-after-today'
  | 'after-maximum'
  | null;

export const getDateNeededByValidationError = (
  date: Date,
  referenceDate = new Date(),
): DateNeededByValidationError => {
  if (!isValid(date)) {
    return 'not-after-today';
  }

  const selectedDate = format(date, 'yyyy-MM-dd');
  const today = referenceDate.toISOString().slice(0, 10);
  const maximumDate = new Date(referenceDate);
  maximumDate.setUTCDate(maximumDate.getUTCDate() + DATE_NEEDED_BY_MAX_DAYS);

  if (selectedDate <= today) {
    return 'not-after-today';
  }

  if (selectedDate > maximumDate.toISOString().slice(0, 10)) {
    return 'after-maximum';
  }

  return null;
};

export const disableDateNeededBy = (date: Date, referenceDate: Date) =>
  getDateNeededByValidationError(date, referenceDate) !== null;
